export type ApiBackend = "functions" | "appservice";

export type ApiBackendEnv = {
  VITE_API_BACKEND?: string;
  VITE_FUNCTIONS_API_URL?: string;
  VITE_APPSERVICE_API_URL?: string;
  VITE_API_URL?: string;
};

export function normalizeApiBaseUrl(url: string | undefined | null): string {
  return String(url ?? "").trim().replace(/\/+$/, "");
}

export function parseApiBackend(value: string | undefined | null): ApiBackend {
  return String(value ?? "").trim().toLowerCase() === "appservice"
    ? "appservice"
    : "functions";
}

export function resolveApiBaseUrlFromEnv(env: ApiBackendEnv): string {
  const backend = parseApiBackend(env.VITE_API_BACKEND);
  const functionsUrl = normalizeApiBaseUrl(env.VITE_FUNCTIONS_API_URL);
  const appServiceUrl = normalizeApiBaseUrl(env.VITE_APPSERVICE_API_URL);
  const fallback = normalizeApiBaseUrl(env.VITE_API_URL);

  if (backend === "appservice") {
    return appServiceUrl || fallback;
  }
  return functionsUrl || fallback;
}

export function resolveApiBaseUrl(): string {
  return resolveApiBaseUrlFromEnv({
    VITE_API_BACKEND: import.meta.env.VITE_API_BACKEND,
    VITE_FUNCTIONS_API_URL: import.meta.env.VITE_FUNCTIONS_API_URL,
    VITE_APPSERVICE_API_URL: import.meta.env.VITE_APPSERVICE_API_URL,
    VITE_API_URL: import.meta.env.VITE_API_URL,
  });
}
